import { DatePicker } from '@mui/x-date-pickers/DatePicker';
interface IDatePicker {
  value: Date | null;
  label: string;
  onChange: (value: Date | null) => void | undefined;
  className?: string;
  maxDate?: Date;
  minDate?: Date;
  error?: boolean;
  onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  defaultCalendarMonth?: Date;
  placeholder?: string;
  helperText?: string;
  disabled?: boolean;
}

export const CustomDatePicker = ({
  className,
  label,
  value,
  onChange,
  maxDate,
  minDate,
  error,
  onBlur,
  defaultCalendarMonth,
  placeholder = 'dd/mm/aaaa',
  helperText,
  disabled,
}: IDatePicker) => {
  return (
    <DatePicker
      label={label}
      value={value}
      defaultValue={defaultCalendarMonth}
      minDate={minDate}
      maxDate={maxDate}
      className={className}
      disabled={disabled}
      onChange={onChange}
      slotProps={{
        textField: {
          variant: 'standard',
          fullWidth: true,
          placeholder,
          onBlur,
          error,
          helperText,
        },
      }}
    />
  );
};
